import type { CorpService as PSCorpService, Service as PSService } from '@ps-int/ps-header/src/header';
import yaTeamDomains from '@ps-int/yandex-services/dist/domains/yandex-team.json';
import type { AnyService } from '@yandex-360/global-bar';

import type { YaServicesConfig } from '../../features/config';
import { createLogger } from '../../helpers/loggerFacade';

const logger = createLogger('header');

export const CORP_LINKS: Record<PSCorpService, string> = {
    At: yaTeamDomains.diary.url,
    Maillists: yaTeamDomains.maillist.url,
    MeetingRooms: `${yaTeamDomains.calendar.url}/invite`,
    Staff: yaTeamDomains.staff.url,
    Startrek: yaTeamDomains.startrek.url,
    Wiki: yaTeamDomains.wiki.url,
    YTeam: yaTeamDomains.yteam.url,
};

export const SELECTED_UID = 'selectedUid';
export const SELECTED_LOGIN = 'selectedLogin';
export const AUTH_PARAMS = [SELECTED_UID, SELECTED_LOGIN];

export const getLinks = (
    yaServices: Record<keyof YaServicesConfig, string>,
    isCorp: boolean
): Record<PSService, string> => ({
    Admin: yaServices.admin,
    Calendar: isCorp ? yaTeamDomains.calendar.url : yaServices.calendar,
    Contact: isCorp ? yaTeamDomains.mail.url + '/#contacts' : yaServices.mail + '/#contacts',
    Concept: yaServices.concept,
    Disk: yaServices.disk,
    Fan: yaServices.fan,
    Mail: isCorp ? yaTeamDomains.mail.url : yaServices.mail,
    Messenger: yaServices.q,
    Notes: yaServices.notes,
    Premium: `${yaServices.yandex360}/business/telemost`,
    Telemost: yaServices.telemost,
    Documents: yaServices.documents,
    Tracker: yaServices.tracker,
    Wiki: yaServices.wiki,
    Forms: isCorp ? yaTeamDomains.forms.url : yaServices.forms,
    NeuroExpert: yaServices.neuroExpert,
});

export const getLinksOverride = (
    yaServices: Record<keyof YaServicesConfig, string>,
    isCorp: boolean,
    selectedUid?: string,
    selectedLogin?: string
): Maybe<Record<Extract<AnyService, 'Messenger'>, string>> => {
    try {
        const links = getLinks(yaServices, isCorp);
        const messengerUrl = new URL(links.Messenger);
        if (selectedUid) {
            messengerUrl.searchParams.set(SELECTED_UID, selectedUid);
        }
        if (selectedLogin) {
            messengerUrl.searchParams.set(SELECTED_LOGIN, selectedLogin);
        }
        return {
            Messenger: messengerUrl.toString(),
        };
    } catch (error) {
        logger.warn(error, { method: 'getLinksOverride' });
        return;
    }
};

export function normalizeRetpath(url: Maybe<string>) {
    if (!url) {
        return;
    }
    try {
        const urlAsObject = new URL(url);
        AUTH_PARAMS.forEach((key) => {
            urlAsObject.searchParams.delete(key);
        });
        return urlAsObject.toString();
    } catch (error) {
        logger.warn(error, { method: 'normalizeRetpath' });
        return url;
    }
}
